import React, { useState } from "react";
import { TextField, Grid, Button } from "@mui/material";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import DialogContentWrapper from "./Components/DialogContentWrapper";
import TableWithPagination from "./Components/TableWithPagination";

const ManageTeamDialog = ({
  DialogOpen,
  handleEventGameCloseDialog,
  teamDetails,
  eventGameTeamDetails,
  setEventGameTeamDetails,
  eventGameTeamEditMode,
  handleSaveEventGameTeamData,
  handleEventGameTeamDelete,
  handleEventGameTeamEdit,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Dynamic columns for the team list
  const columns = [{ label: "Team Name", field: "teamName", align: "left" }];

  return (
    <DialogContentWrapper
      open={DialogOpen}
      onClose={handleEventGameCloseDialog}
      title="Manage Game Teams"
      icon={<ManageAccountsIcon color="primary" sx={{ marginRight: 1 }} />}
    >
      <Grid container spacing={2} style={{ padding: "20px 24px" }}>
        <Grid item xs={6} sm={8}>
          <TextField
            label="Enter Team Name"
            variant="outlined"
            fullWidth
            size="small"
            value={eventGameTeamDetails?.teamName || ""}
            onChange={(event) =>
              setEventGameTeamDetails((prev) => ({
                ...prev,
                teamName: event.target.value,
              }))
            }
          />
        </Grid>
        <Grid item xs={6} sm={4}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSaveEventGameTeamData(eventGameTeamDetails)}
          >
            {eventGameTeamEditMode ? "Update" : "Add"}
          </Button>
        </Grid>
      </Grid>
      <TableWithPagination
        title={"Team List"}
        columns={columns}
        rows={teamDetails}
        rowsPerPage={rowsPerPage}
        page={page}
        handlePageChange={(e, newPage) => setPage(newPage)}
        handleRowsPerPageChange={(e) =>
          setRowsPerPage(parseInt(e.target.value, 10))
        }
        handleEdit={handleEventGameTeamEdit}
        handleDelete={handleEventGameTeamDelete}
      />
    </DialogContentWrapper>
  );
};

export default ManageTeamDialog;
